import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, TextLink } from '@vds/buttons';
import { Title, Body } from '@vds/typography';
import { Row, Col, Grid } from '@vds/grids';
import './InternetOptions.css';
import { redirectionHandler } from '../containers/action';
import { isMobile } from 'react-device-detect';
import * as SiteCatalyst from '../../../sitecatalyst';  
import { isNightTimeWindow } from './../../../utils/common';
import {
    postUIEventLog
} from '../containers/action';
class InternetOptions extends Component {
        constructor(props) {
            super(props);
            window.scrollTo(0, 0);
            props.postUIEventLog({ eventType: 'log', eventName: "INTERNETOPTIONS_PageLoad", sectionName: "Page" });
            this.state= {
                endInteraction: false,
            };
        }
        componentDidMount() {
            this.setState({ endInteraction: true });
        }
    
        componentDidUpdate = () => {
            if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
                window.newrelic.interaction().end();
                this.setState({ endInteraction: false });
            }
        }
        btnHandler = (hsiFlow) => {
           if(hsiFlow){
            this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
            let doLoopResponse = this.props.addressQualificationDetails;
            if ( !isNightTimeWindow()) {
                SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                SiteCatalyst.trackProductsList(window.LQResponse);
                SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
           } else{
            this.props.redirectionHandler()
           } 
        }
    render() {
        let doLoopResponse = this.props.addressQualificationDetails;

    return (
        <>
           <Grid className="OutofFranchise" style= {{marginLeft:'3px'}} colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }} colGutter={false}>
                <Row className="Page-Content">
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                            {isMobile ? <Title size="large" primitive="h2">
                            Your address qualifies for multiple business internet services.
                            </Title> :
                            <Title size="large" primitive="h2">
                            Your address qualifies for multiple <br />business internet services.
                            </Title> }
                        </div>
                    </Col>
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                            <Title size="small" primitive="h2">
                            LTE Business Internet
                            </Title>
                        </div>
                        <div>
                        <Body size="large" primitive="h2">With speeds up to 50 Mbps, LTE Business Internet is ideal for small office, retail, kiosk and mobile businesses. Each plan includes 300GB of  monthly data without speed thresholds, no matter how much of your data you use. Great for email, web browsing, file sharing and point of sale systems.
                        </Body>
                        </div>
                    </Col>
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className={`${isMobile ? "io-btn" : "Main-Title"}`}>
                        <Button primary size="large" onClick={() => this.btnHandler(false)} >Shop LTE Business Internet</Button>

                        </div>
                    </Col>
                </Row>
              
                <Row className="Page-Content">
                {doLoopResponse.LQPost?.HSIStatus === 'Y' && 
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                      <Body size="large" primitive="h2"> High speed internet, with speeds up to 20 Mbps, is also available in your area.</Body>
                      <TextLink onClick={() => this.btnHandler(true)}>Shop High Speed Internet</TextLink>
                        </div>
                    </Col>
    }
                    </Row>
  
  
                    <Row className="Page-Content">
                    {doLoopResponse.LQPost?.HSIStatus !== 'Y' && doLoopResponse.IDEQualified ==='Y' &&
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                    <div className="Main-Title">
                    <Title size="small" primitive="h2">  
                                <span> Internet Dedicated Service</span>
                           </Title>
                           </div>
                      {/* <Body size="large" primitive="h2"> Reliable high performance internet suited to meet the demands of cloud technology for busiesses in any location</Body> */}
                      <div style={{marginTop:'5px'}}><Body size="large" primitive="h2"> 
                      Internet Dedicated Services uses ultrafast, full-duplex connections to deliver scalable internet connectivity. It can help you support high-bandwidth applications, easily share information and enable high-speed transactions. Burstable and tiered pricing options help you dial up bandwidth with demand.
                     </Body></div>
                      <div className="Main-Title">
                      <Button  secondary size="large" onClick={() => this.props.history.push("/contact")}>Contact Sales </Button>
                        </div>
                    </Col>
    }
                    </Row> 
            </Grid >
        </>);
}
}

const mapStateToProps = (state) => {
    const { AddressValidationPage } = state;
    return {
        addressQualificationDetails: AddressValidationPage.addressQualificationDetails
    };
};
const mapDispatchToProps = (dispatch) => ({
    redirectionHandler: (data) => { dispatch(redirectionHandler(data)); },
    postUIEventLog: (data) => { dispatch(postUIEventLog(data)) }, 

})

export default connect(mapStateToProps, mapDispatchToProps)(InternetOptions)